import { render, staticRenderFns } from "./SelectDesignType.vue?vue&type=template&id=d9b9b1e4&scoped=true&"
import script from "./SelectDesignType.vue?vue&type=script&lang=js&"
export * from "./SelectDesignType.vue?vue&type=script&lang=js&"
import style0 from "./SelectDesignType.vue?vue&type=style&index=0&id=d9b9b1e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b9b1e4",
  null
  
)

export default component.exports